<template>
  <div class="km__modules__logo--list">
    <button class="km__button--back" type="button" name="back" @click="$emit('closeModule')" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="$emit('closeModule')"
            aria-label="close"></button>
    <ul v-if="logoList.length > 0" class="km__list--modules">
      <li
          v-for="(item) in logoList"
          :key="item.logoID"
          class="km__list__element--modules"
      >
        <div class="logo__element">
          <div class="logo__element__preview">
            <img width="50" :src="item.previewPicture||item.pathToLogo" :alt="item.name"/>
          </div>
          <div class="logo__element__buttons">
            <span class="km__button--text edit" @click="getLogo(item.id)">Bearbeiten</span>
            <span class="km__button--text delete" @click="$emit('deleteLogoElem', item.id)"></span>
          </div>
        </div>
      </li>
    </ul>
    <div v-else>
      Keine Logos vorhanden!
    </div>
  </div>
</template>

<script lang="ts" setup>

import {EventVerteiler} from "@k/global/eventVerteiler";
import {watch} from "vue";
import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";

const props = defineProps({
  logoList: {type: Array, required: true}
})

const emit = defineEmits(["closeModule", "deleteLogoElem"]);

watch(() => props.logoList, logolist => {
  if (logolist!.length === 0) {
    emit("closeModule")
  }
})
const store = useStore();
const animation = AnimationWaitingForTargetFactory.getUpDownAnimation('.km__modules__logo--list');
const keyFrames = new KeyFrameTargetValues(0, 200);
const openStatusStore = useModuleLogoOpenStateStore();
watch(() => openStatusStore.getListState, newState => animation(keyFrames.getTarget(newState)));

const getLogo = id => EventVerteiler.broadcast("selObSelectedFromRahmen", id)

</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__logo--list {
  position: fixed;
  height: 180px;
  width: 100%;
  left: 0;
  bottom: config.$cta-height;
  z-index: 99;
  background: config.$color-white;
  padding: 55px 0 20px 10px;
  transform: translate(0px, 180px);
  overflow-y: hidden;

  .km__list--modules {
    position: relative;
    padding-bottom: 150px;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
  }
}

.logo__element {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}

.logo__element__buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .km__button--text {
    width: 50%;
  }
}

.logo__element__preview {
  width: 70px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid config.$color-btn-border;
  overflow: hidden;

}
</style>
